import React, {Component} from "react";
import settings from "../../configs/appSettings";
import {withRouter} from "react-router-dom";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import _ from "lodash";
import {setTopRailNavigation} from "../../actions/nav/topRailNavAction";
import {transferToProduct} from "../../actions/nav/productTransferAction";
import {UserMenuModel} from "../../models/platformUserModel";

class AppSwitcherNav extends Component {

    static propTypes = {
        history: PropTypes.object,
        isActive: PropTypes.bool,
        setTopRailNavigation: PropTypes.func,
        initiateProductTransfer: PropTypes.func,
        user: PropTypes.shape(UserMenuModel)
    };

    static defaultProps = {
        isActive: undefined
    };

    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        window.addEventListener("click", this.closeAppSwitcherMenuIfOpen);
    }

    componentWillUnmount() {
        window.removeEventListener("click", null);
    }

    closeAppSwitcherMenuIfOpen = (e) => {
        if (this.props.isActive) {
            const userClickedOutsideOfMenu = !(_.find(e.path, (p) => {
                return p.className && p.className.includes('app-switcher-menu');
            }));
            if (userClickedOutsideOfMenu) {
                this.toggleAppSwitcherMenu(e);
            }
        }
    };

    toggleAppSwitcherMenu = (e) => {
        e.stopPropagation();
        if (_.isUndefined(this.props.user)) { return; }
        this.props.setTopRailNavigation(this.props.isActive ? '' : 'Applications');
    };

    handleProductTransferLinkClick = productId => {
        this.props.initiateProductTransfer(productId);
    };

    render() {
        const {isActive, user} = this.props;

        const appIconLinks = isActive && !_.isUndefined(user)
            ? _.uniqBy(_.orderBy(user.products, ["displayName"]), "icon")
                .map(product => {
                    return (
                        <li className="app-switcher-link"
                            key={product.id}
                            onClick={() => this.handleProductTransferLinkClick(product.name)}>
                            <a><img src={`${product.icon}`} alt={product.displayName}/></a>
                        </li>);
                })
            : undefined;

        const appSwitcherMenu = isActive
            ? <div className="top-nav-menu app-switcher-menu">
                <div className="arrow"/>
                <div className="menu-content">
                    <ul>
                        {appIconLinks}
                    </ul>
                </div>
            </div>
            : undefined;

        const activeNavBackground = isActive
            ? <div className="active-nav-icon-background"/>
            : undefined;

        return (
            <div>
                <div className="top-rail-icon-container tooltip is-tooltip-bottom"
                     data-tooltip="Applications"
                     onClick={this.toggleAppSwitcherMenu}>
                    <div className="nav-img-container">
                        <img src={`${settings.cdnUrlIcons}/app-switcher.svg`} alt="applications"/>
                    </div>
                    <div className="hovered-nav-icon-background"/>
                    {activeNavBackground}
                </div>
                {appSwitcherMenu}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.platformUser.user,
        isActive: state.topRailNav.activeElementId === 'Applications'
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setTopRailNavigation: selectedElementId => dispatch(setTopRailNavigation(selectedElementId)),
        initiateProductTransfer: (productId) => dispatch(transferToProduct(productId))
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppSwitcherNav));
